import AdminDashboardReducer from './AdminDashboardReducer';

export default from './AdminDashboardContainer';
export const AdminDashboardReducers = { AdminDashboardReducer };
